import UserProfile from './UserProfile';

export class UserUpdate {
  public FirstName = '';
  public LastName = '';
  public UserName = '';
  public Email = '';
  public Document = '';
  public DocumentType = '';
  public PhoneNumber = '';
  constructor(profile?: UserProfile) {
    if (profile) {
      this.FirstName = profile.FirstName!;
      this.LastName = profile.LastName!;
      this.UserName = profile.UserName!;
      this.Email = profile.Email!;
      this.Document = profile.Document!;
      this.DocumentType = profile.DocumentType!;
      this.PhoneNumber = profile.PhoneNumber!;
    }
  }
}
